export const REPONAME_ANNOTATION = 'google.com/cloudbuild-repo-name';
